export interface SideNavMenuItem {
  labelKey: string;
  navigateTo: string;
  image: string;
  exactMatch?: boolean;
  alsoActiveFor?: string[];
}

export const MENU_ITEMS: SideNavMenuItem[] = [
  { labelKey: "item.1", navigateTo: "dashboard", image: "dashboard", exactMatch: true },
  { labelKey: "item.2", navigateTo: "profile", image: "profile" },
  { labelKey: "item.3", navigateTo: "trade2earn", image: "trade2earn" },
  {
    labelKey: "item.4",
    navigateTo: "accounts",
    image: "accounts",
    alsoActiveFor: ["/dashboard/challenges"],
  },
  { labelKey: "item.6", navigateTo: "payouts", image: "payouts" },
  { labelKey: "item.12", navigateTo: "contracts", image: "contracts" },
  { labelKey: "item.7", navigateTo: "affiliate/dashboard", image: "affiliate" },
  { labelKey: "item.8", navigateTo: "trading-academy", image: "academy" },
  { labelKey: "item.9", navigateTo: "billing", image: "billing" },
  { labelKey: "item.10", navigateTo: "download", image: "download" },
  { labelKey: "item.11", navigateTo: "contact-us", image: "contact" },
] as const;

export const FUTURES_MENU_ITEMS: SideNavMenuItem[] = [
  { labelKey: "item.1", navigateTo: "futures/dashboard", image: "dashboard", exactMatch: true },
  { labelKey: "item.2", navigateTo: "profile", image: "profile" },
  { labelKey: "item.3", navigateTo: "futures/trade2earn", image: "trade2earn" },
  {
    labelKey: "item.4",
    navigateTo: "futures/accounts",
    image: "accounts",
    alsoActiveFor: ["/futures/dashboard/challenges"],
  },
  { labelKey: "item.6", navigateTo: "futures/payouts", image: "payouts" },
  { labelKey: "item.12", navigateTo: "futures/contracts", image: "contracts" },
  { labelKey: "item.7", navigateTo: "futures/affiliate", image: "affiliate" },
  { labelKey: "item.8", navigateTo: "trading-academy", image: "academy" },
  { labelKey: "item.9", navigateTo: "billing", image: "billing" },
  { labelKey: "item.10", navigateTo: "futures/download", image: "download" },
  { labelKey: "item.11", navigateTo: "contact-us", image: "contact" },
] as const;
